$(function() {
    const cookieName = 'edc-alerts';
    const cookieLifetime = 365;
    let cookieVal = getCookie(cookieName);
    let cookieValArray = [];

    if(cookieVal) {
        cookieValArray = cookieVal.split('|');
    }

    $('.alert-banner').each(function() {
        let alertID = $(this).data('alert-id');
        if( cookieValArray.indexOf(alertID) < 0 ) {
            $(this).show();
        }
    });

    $('.alert-banner__close').on('click', function() {
        let alertBanner = $(this).closest('.alert-banner');
        let alertID = alertBanner.data('alert-id');
        cookieValArray.push(alertID);
        let cookieValNew = cookieValArray.join('|');
        setCookie(cookieName, cookieValNew, cookieLifetime);
        alertBanner.hide();
    });

    function setCookie(name, value, days) {
        var d = new Date;
        d.setTime(d.getTime() + 24*60*60*1000*days);
        document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
    }

    function getCookie(name) {
        var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
        return v ? v[2] : null;
    }

});